import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAdminDashboardCardsApi, getAffiliateuserlist, getAnalyticsDataApi, getAnalyticsGraphDataApi } from "../../Api/AdminApiCall";


export const fetchAdminDashboardCards = createAsyncThunk(
    "admin/fetchDashboardCards",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getAdminDashboardCardsApi();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAffiliateUserList = createAsyncThunk(
    "admin/fetchAffiliateUserList",
    async ({ page = 1, search = '' } = {}, { rejectWithValue }) => {
        try {
            const res = await getAffiliateuserlist(page, search);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load affiliate user list"
            );
        }
    }
);

export const fetchAnalyticsCrdsList = createAsyncThunk(
    "admin/fetchAnalyticsCrdsList",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getAnalyticsDataApi();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message ||
                error?.response?.data ||
                "Failed to load analytics cards list"
            );
        }
    }
);

export const fetchAnalyticsGraphData = createAsyncThunk(
    "admin/fetchAnalyticsGraphData",
    async (period, { rejectWithValue }) => {
        try {
            const res = await getAnalyticsGraphDataApi(period);
            return res.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || "Failed to load analytics graph data");
        }

    }
);

// getAnalyticsData

const adminSlice = createSlice({
    name: "adminDashboard",
    initialState: {
        dashboardCards: [],
        UsersActivity: [],
        AnalyticsCards: [],
        loading: false,
        error: null,
        AnalyticsGraphData: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdminDashboardCards.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdminDashboardCards.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboardCards = action.payload;
            })
            .addCase(fetchAdminDashboardCards.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAffiliateUserList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateUserList.fulfilled, (state, action) => {
                state.loading = false;
                state.UsersActivity = action.payload;
            })
            .addCase(fetchAffiliateUserList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAnalyticsCrdsList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsCrdsList.fulfilled, (state, action) => {
                state.loading = false;
                state.AnalyticsCards = action.payload;
            })
            .addCase(fetchAnalyticsCrdsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAnalyticsGraphData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsGraphData.fulfilled, (state, action) => {
                state.loading = false;
                state.AnalyticsGraphData = action.payload;
            })
            .addCase(fetchAnalyticsGraphData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }

});

export const { clearAdminDashboardState } = adminSlice.actions;

export default adminSlice.reducer;
